import React from 'react';

interface ProductCardProps {
  image: string;
  title: string;
  category: string;
}

const ProductCard: React.FC<ProductCardProps> = ({ image, title, category }) => {
  return (
    <div className="flex flex-col cursor-pointer justify-between">
      <img
        src={image}
        alt={title}
        className="object-contain w-full rounded-3xl aspect-[0.7] rounded-2xl border-3 border-yellow-400 border-solid object-contain max-h-[300px]"
      />
      <div className="mt-2 mb-1 text-xl font-bold text-black">{title}</div>
      <div className="text-base font-bold text-black">{category}</div>
    </div>
  );
};

export default ProductCard;